<header class="background-header classic-background"></header>
<section class="main-side-nav"
    [ngClass]="{hideOnMobile:sideNavBarVisibilityService.hideOnMobile==true, 'main-side-nave-theme': themeService.theme != 'default'}">
    <section class="container admin-dashboard-parent refcodes-container copy-editor-container">
        <section class="template-section-title">
            <div class="breadcrumb-container">
                <span>Admin <i class="fa fas fa-chevron-right"></i></span>
                <app-breadcrumb [pageName]="'Auditlog'" [isTopLevel]="true"></app-breadcrumb>
            </div>
            <div class="title-container">
                <h1>Audit Log</h1>
            </div>
        </section>
        <div class="notification-bubble-container">
            <app-notification-bubble></app-notification-bubble>
        </div>
        <section class="all-users-data">
            <div class="table-responsive admin-dashboard-table">
                <table class="table table-borderless table-hover">
                    <thead>
                        <tr>
                            <th scope="col">IP</th>
                            <th scope="col">Event</th>
                            <th scope="col">Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngIf="list">
                            <ng-container *ngFor="let item of list">
                                <tr class="body-header" (click)="toggleSection(item._id)">
                                    <td>{{item.ip}}</td>
                                    <td>{{item.event}}</td>
                                    <!-- date:'MM/dd/yyyy' -->
                                    <td>{{item.timestamp | date:'MM/dd/yyyy'}}</td>
                                </tr>
                                <tr class="body-body"
                                    [ngClass]="{'hide':selectedItemCode!=item._id,'expanded':selectedItemCode === item._id}">
                                    <td colspan="3">
                                        <section class="body-container">
                                            <label>
                                                <span class="label">Id</span>
                                                <input type="text" [(ngModel)]="item._id" readonly>
                                            </label>
                                            <label>
                                                <span class="label">IP</span>
                                                <input type="text" [(ngModel)]="item.IP" readonly>
                                            </label>
                                            <label>
                                                <span class="label">Event</span>
                                                <input type="text" [(ngModel)]="item.event" readonly>
                                            </label>
                                            <label *ngIf="item.metadata">
                                                <span class="label">UserType</span>
                                                <input type="text" [(ngModel)]="item.metadata.userType" readonly>
                                            </label>
                                            <label *ngIf="item.metadata">
                                                <span class="label">URL</span>
                                                <input type="text" [(ngModel)]="item.metadata.url" readonly>
                                            </label>
                                        </section>
                                    </td>
                                </tr>
                            </ng-container>
                        </ng-container>
                    </tbody>
                </table>
            </div>
            <div class="pagination-controls-container">
                <app-pagination [currentPage]="page" [totalPages]="totalPages"
                    (pageChange)="loadUsers($event)"></app-pagination>
            </div>
        </section>
    </section>
</section>
